import {KeyConstant} from "../../../can/weighing-slip/constant/keyConstant";
import moment from "moment";

export const KeyConstantTab = {
    DATE : {
        title: "Ngày",
        key: "date",
        type: KeyConstant.TODAY,
        startDate: moment(),
        endDate: moment()
    },
    WEEK : {
        title: "Tuần",
        key: "week",
        type: KeyConstant.THIS_WEEK,
        startDate: moment().startOf("week"),
        endDate: moment().endOf("week"),
    },
    MONTH : {
        title: "Tháng",
        key: "month",
        type: KeyConstant.THIS_MONTH,
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month"),
    },
    CUSTOM : {
        title: "Tùy chỉnh",
        key: "custom",
        type: KeyConstant.CUSTOM,
        startDate: moment(),
        endDate: moment()
    },
}
